const USNoticeIncentiveLink = '/beauty/privacy-policy#USNoticeIncentive';
const TEXT_TERM_LINK = '/beauty/sms-terms-and-conditions';
const PRIVACY_POLICY_LINK = '/beauty/privacy-policy';

export {
    USNoticeIncentiveLink, TEXT_TERM_LINK, PRIVACY_POLICY_LINK
};
